export const Relationships = {
  Self: {
    key: 'self',
    label: 'Self'
  },
  Spouse: {
    key: 'spouse',
    label: 'Spouse'
  },
  Child: {
    key: 'child',
    label: 'Child'
  },
  SponsoredDependent: {
    key: 'sponsored_dependent',
    label: 'Sponsored Dependent'
  },
  StepsonStepdaughter: {
    key: 'stepson_stepdaughter',
    label: 'Stepchild'
  },
};

export type Relationship = keyof typeof Relationships;
